<template>
  <div>
    <Head title="Edit Mail PDF" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/mail/pdfs">Mail PDFs</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit Mail Template</li>
      </ol>
    </nav>
    <h1>Edit Mail PDF</h1>

    <div class="content-box">
      <form @submit.prevent="update">
        <div class="mb-3">
          <text-input v-model="form.name" :error="form.errors.name" label="Name" />
          <text-input v-model="form.file" :error="form.errors.file" label="file" disabled />
        </div>

        <div class="actions-toolbar">
          <button v-if="!mailpdfs.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete PDF</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Edit PDF</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import MailTemplateForm from './components/MailTemplateForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    TextInput,
    MailTemplateForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    mailpdfs: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.mailpdfs.name,
        file: this.mailpdfs.file
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/mail/pdfs/${this.mailpdfs.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this mail template?')) {
        this.$inertia.delete(`/settings/mail/pdfs/${this.mailpdfs.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this mail template?')) {
        this.$inertia.put(`/settings/mail/pdfs/${this.mailpdfs.id}/restore`)
      }
    },
  },
}
</script>
